var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material';
import { blue50opacity50 } from '../../../colors/blue';
import { gray80, white } from '../../../colors/gray';
import { MuiListItemButton } from './MuiListItemButton';
import { rem } from '../../../utils/rem';
var topNavItemStyles = MuiListItemButton.customOverrides.topNavItem;
export var MuiAppBar = {
    styleOverrides: {
        root: {
            '& [class*=MuiTypography-appName]': {
                marginInlineEnd: rem(48),
            },
            '& nav[class*=MuiList]:last-child': {
                marginInlineStart: 'auto',
            },
            '& [data-component=action-group-container]': {
                flex: '1 1 0%',
                button: __assign(__assign({}, topNavItemStyles), { minWidth: 'min-content', color: 'inherit', "& [class*='MuiTypography-root']": {
                        fontWeight: topNavItemStyles.fontWeight,
                    } }),
                // If action group menu has selected item inside, then apply selected styles to it.
                "& button[data-has-selected='true']": topNavItemStyles['&[class*=Mui-selected]'],
                "& button[data-has-selected='true']:hover": {
                    backgroundColor: alpha(blue50opacity50, 0.12),
                },
            },
        },
        colorPrimary: {
            backgroundColor: white,
            color: gray80,
        },
    },
    customOverrides: {
        popout: {
            '& [class*=MuiTypography-appName]': {
                fontSize: '0.875rem',
            },
            '& [class*=MuiToolbar-regular]': {
                minHeight: rem(34),
            },
        },
    },
};
